var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12.5L22.6924 30.5H1.90774L12.3 12.5Z",
    fill: "#DD9302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12.5076L33.0847 12.5076L22.6924 30.5076L12.3 12.5076Z",
    fill: "#C03939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12.5076L22.6924 -5.4924L33.0847 12.5076L12.3 12.5076Z",
    fill: "#922CD0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 12.5L1.90775 -5.5L22.6924 -5.5L12.3 12.5Z",
    fill: "#354ED1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.44995 12.5076L1.94235 -5.4924L12.3347 12.5076L-8.44995 12.5076Z",
    fill: "#2CD08C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.5 12.5076L12.2846 12.5076L1.8923 30.5076L-8.5 12.5076Z",
    fill: "#C0B239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColors);
export default __webpack_public_path__ + "static/media/colors.99d7c04f7d30570a0eeba4a1827345a3.svg";
export { ForwardRef as ReactComponent };